export const SOFTLINE_FEATURE_PRODUCT_SCAN = 'productScan';
export const SOFTLINE_PERMISSION_ARTIKELINFO = 'ITEMSCAN';
